jQuery( $ => {

    const form      = document.getElementById('partner-filter-form');
    const container = document.getElementById('partners-list');
    const loadmore  = document.getElementById('loadmore-parnters');

    if( !form || !loadmore || !container ){
        return;
    }

    // blocks form submit
	form.addEventListener( 'submit', e => e.preventDefault());

    // Select field change
    form.querySelectorAll( 'select' ).forEach( el => el.addEventListener('change', filter_parnters ) )

    // Loadmore click event
    loadmore.addEventListener('click', () => filter_parnters('loadmore') );

    // Search input
	let timeoutId;
    const search = form.querySelector('.search-partners');
    if( search ){
        search.addEventListener("input", () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => filter_parnters(), 800 );
        });
    }



    /**
     * Filtering function
     * @param {string} mode 
     */
    function filter_parnters(mode = ''){

        const spinner = $("#spinner");
        spinner.fadeIn();

        const formdata = new FormData(document.getElementById('partner-filter-form'));

        data                = {};
        data.page           = parseInt(formdata.get("page")) + 1;
        data.per_page       = formdata.get("per_page");
        data.search         = formdata.get("s");
        data.group          = formdata.get("group");
        data.is_loadmore    = 'loadmore' == mode;

        $.ajax({
            type: "GET",
            url: restApi.url + "api/v1/partners/get",
            beforeSend: function (xhr) {
                xhr.setRequestHeader("X-WP-Nounce", restApi.nonce);
            },
            data: data,
        })
        .success(function (response) {
            
            if (response.total_found > 0) {

                // update content
                // https://developer.chrome.com/docs/web-platform/view-transitions
                if (!document.startViewTransition) {
                    if( 'loadmore' == mode ){
                        $(container).append(response.body);
                    }else{
                        $(container).html(response.body);
                    }
                }else{
                    document.startViewTransition(() => {
                        if( 'loadmore' == mode ){
                            $(container).append(response.body);
                        }else{
                            $(container).html(response.body);
                        }
                    });
                }

                // update page number
                document.querySelector('input[name="page"]').value = response.page;

                // update button
                if (response.page < response.max_pages) {
                    loadmore.style.display = "inline-flex";
                }else{
                    loadmore.style.display = "none";
                }

                spinner.fadeOut();
            }
        })
        .fail(function (err) {
            console.log(err);
        });
    }

});